import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from "./authentication.service";

@Injectable({providedIn: 'root'})
export class AuthenticationGuard implements CanActivate, CanActivateChild {
  
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
    ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticationService.isAuthenticated() && this.authenticationService.isAdministrator) {
      return true;
    } else {
      this.authenticationService.logout();
      this.router.navigate(['/admin']);
      return false;
    }
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
